import { fetchBusinessList } from '@/api/business';
import types from '../types';

const state = {
  business: [],
};

const mutations = {
  [types.SET_BUSINESS](state, business) {
    state.business = business;
  }
};

const actions = {
  fetchBusinessList({ commit }) {
    this.tableLoading = true;
    return fetchBusinessList()
      .then(res => {
        const business = res.data.data || [];
        commit(types.SET_BUSINESS, business);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/business.js